export default __webpack_public_path__ + "static/waxringandsilverringonringstick-a735943b1132db46ad9ead6ea4268d3d.png";